module.exports = __webpack_public_path__ + "media/student_v2/assets/images/student-alert-chevron-up-294876216808333b53fefca5d5f79150.svg";